import type { TFunction } from "i18next";
import { MAX_STAY_CHILD_AGE } from "@majourneys/shared";
import type { MenuOption } from "@majourneys/ui";

/**
 * Every age a child can be booked at, 0 to 17.
 *
 * Shared by the search form and the property sidebar because the two must
 * offer the same ages under the same words: a guest who picks "under 1" on the
 * landing page and then sees "0 years" in the sidebar has been shown two
 * different questions about the same child.
 *
 * Zero is written out rather than left as a bare digit — "0 years old" reads as
 * a missing value, and the supplier's cheapest band is the one most likely to
 * be picked by accident.
 */
export function childAgeOptions(t: TFunction): MenuOption[] {
  return Array.from({ length: MAX_STAY_CHILD_AGE + 1 }, (_, years) => ({
    value: String(years),
    label:
      years === 0
        ? t("stays.detail.sidebar.child_under_one")
        : t("stays.detail.sidebar.child_years", { count: years }),
  }));
}

/** The label for one age, for a trigger's accessible name. */
export function childAgeLabel(t: TFunction, age: number): string {
  return age === 0
    ? t("stays.detail.sidebar.child_under_one")
    : t("stays.detail.sidebar.child_years", { count: age });
}
